const normalizeUrl = (value = "") => {
  return String(value).trim().replace(/\/+$/, "");
};

const siteName = process.env.REACT_APP_SITE_NAME?.trim() || "ResultWale";

const siteUrl = normalizeUrl(
  process.env.REACT_APP_SITE_URL || "https://www.resultwale.in",
);

const apiUrl = normalizeUrl(
  process.env.REACT_APP_API_URL || "http://localhost:5000/api",
);

const siteConfig = {
  /* =========================
     Basic branding
  ========================= */

  name: siteName,

  shortName: "ResultWale",

  logoText: "ResultWale",

  logoMark: "RW",

  storagePrefix: "resultwale",

  tagline: "Jobs, Results, Admit Cards & Exam Updates",

  topbarText: "Fast updates for government jobs, results, admit cards and exams",

  navbarTagline: "Jobs • Results • Admit Cards • Exams",

  footerTagline: "Government Career & Education Updates",

  /* =========================
     Website URLs
  ========================= */

  url: siteUrl,

  apiUrl,

  /* =========================
     Default SEO
  ========================= */

  defaultTitle: `${siteName} - Latest Jobs, Results & Admit Cards`,

  description: `${siteName} brings the latest government jobs, Sarkari results, admit cards, admissions, scholarships, syllabus updates and useful online services across India.`,

  keywords: [
    "sarkari result",
    "government jobs",
    "latest jobs",
    "sarkari naukri",
    "government vacancy",
    "admit card",
    "exam result",
    "results",
    "online services",
    "online apply",
    "admission",
    "scholarship",
    "syllabus",
    "answer key",
    "exam date",
    "government exam",
  ],

  language: "en-IN",

  locale: "en_IN",

  country: "India",

  /* =========================
     Footer content
  ========================= */

  footerDescription:
    "A clean, organized portal for latest jobs, Sarkari results, admit cards, admissions, scholarships, syllabus and online service updates.",

  disclaimerText: `${siteName} is an independent information portal and is not affiliated with any government organization. Always verify important details through the official notification or official website.`,

  copyright: `© ${new Date().getFullYear()} ${siteName}. All rights reserved.`,

  /* =========================
     Contact information
  ========================= */

  supportEmail: "support@resultwale.in",

  contact: {
    email: "support@resultwale.in",

    phone: "",

    address: "",

    workingHours: "Monday to Saturday (10:00 AM - 6:00 PM IST)",
  },

  /* =========================
     Social media

     Add ResultWale's verified/official profiles here
     when they are created. Old project profiles are
     intentionally not reused for the new brand.
  ========================= */

  social: {
    facebook: "",
    instagram: "",
    x: "",
    youtube: "",
    telegram: "",
  },

  /* =========================
     Public assets
  ========================= */

  assets: {
    logo: "/logo192.png",
    favicon: "/favicon.png",
    defaultOgImage: "/og-image.jpg",
    appleTouchIcon: "/logo192.png",
  },

  /* =========================
     Theme information
  ========================= */

  theme: {
    primaryColor: "#155EEF",
    accentColor: "#F59E0B",
    backgroundColor: "#F6F8FC",
  },

  /* =========================
     Organization information
  ========================= */

  organization: {
    name: siteName,
    legalName: siteName,
    publisherName: siteName,
    authorName: siteName,
    url: siteUrl,
    email: "support@resultwale.in",
  },

  /* =========================
     Routes
  ========================= */

  routes: {
    home: "/",
    about: "/about",
    contact: "/contact",
    privacy: "/privacy-policy",
    disclaimer: "/disclaimer",
    editorialPolicy: "/editorial-policy",
    correctionsPolicy: "/corrections-policy",
    search: "/search",
    login: "/login",
    admin: "/admin",
    adminPosts: "/admin/posts",
  },

  /* =========================
     External services
  ========================= */

  analytics: {
    measurementId: process.env.REACT_APP_GA_MEASUREMENT_ID?.trim() || "",
  },

  adsense: {
    enabled: process.env.REACT_APP_ADSENSE_ENABLED === "true",
    client: process.env.REACT_APP_ADSENSE_CLIENT?.trim() || "",
  },
};

export default siteConfig;
